export default __webpack_public_path__ + "static/media/doc_excluido-02.d4b303ac.svg";